import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import brands from '../data/brands.json';
import company from '../data/company.json';
import styles from './Footer.module.css';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className={styles.footer}>
      <div className={styles.top}>
        <div className="container">
          <div className={styles.grid}>
            {/* Brand */}
            <div className={styles.col}>
              <div className={styles.logoWrap}>
                <img src="/motamakina-logo-removebg-preview.png" alt="AL Motamakina" className={styles.logoImg} />
                <span className={styles.logoText}>AL <span className={styles.logoAccent}>Motamakina</span></span>
              </div>
              <p className={styles.desc}>{company.description}</p>
            </div>

            {/* Brands */}
            <div className={styles.col}>
              <h4 className={styles.colTitle}>Our Brands</h4>
              <ul className={styles.links}>
                {brands.map((b) => (
                  <li key={b.id}>
                    <Link to={`/brands/${b.slug}`} className={styles.link}>
                      <span className={styles.dot} style={{ background: b.color }} />
                      {b.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Quick Links */}
            <div className={styles.col}>
              <h4 className={styles.colTitle}>Quick Links</h4>
              <ul className={styles.links}>
                {['About Us', 'Services', 'Contact Us'].map((l) => (
                  <li key={l}><Link to={`/#${l.toLowerCase().replace(/ /g, '-')}`} className={styles.link}>{l}</Link></li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div className={styles.col}>
              <h4 className={styles.colTitle}>Contact</h4>
              <ul className={styles.contactList}>
                <li><MapPin size={14} /> {company.contact.address}</li>
                <li><Phone size={14} /> {company.contact.phone}</li>
                <li><Mail size={14} /> {company.contact.email}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.bottom}>
        <div className="container">
          <p>© {year} AL Motamakina. All rights reserved.</p>
          <p>Authorized Distributor for CompAir, Elmo Rietschle, Belliss & Morcom, Friulair, Pedro Gil, FST Air Pipe & TMG Power</p>
        </div>
      </div>
    </footer>
  );
}
